import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-center"
}
const _hoisted_2 = {
  key: 0,
  class: "text-base font-medium"
}
const _hoisted_3 = {
  key: 1,
  class: "flex flex-col items-center space-y-2"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = {
  key: 1,
  class: "flex justify-center w-full h-full bg-gray-300 border-2 border-dashed border-light-gray-200 rounded-base items-center"
}
const _hoisted_6 = { class: "w-40 h-fit text-center p-3 overflow-clip text-ellipsis" }
const _hoisted_7 = { class: "w-full flex justify-center items-center" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "absolute -mb-3 text-light-gray-100 font-semibold" }, "PDF", -1)
const _hoisted_9 = { class: "italic" }
const _hoisted_10 = ["id", "name", "accept", "multiple"]
const _hoisted_11 = { class: "block text-sm text-error" }
const _hoisted_12 = {
  key: 3,
  class: ""
}

import { useField } from "vee-validate"
  import { toastController } from "@ionic/core"
  import { ref, Ref, watch } from "vue"
  import { first } from "lodash"
  import { useExternalStore } from "@/store/external"
  import jwt from "@/utils/jwt"
  import { forEach } from "lodash"
  import { PhotoIcon, DocumentIcon, XCircleIcon } from "@heroicons/vue/24/solid"

  interface Props {
    id: string
    name: string
    modelValue: string
    accepts?: string
    folder: string
    multiple?: boolean
    borderDashed?: boolean
    inputPlaceholder?: string
    hidePlaceholder?: boolean
  }

  type Link = {
    image: string
    label: string
  }
  
export default /*#__PURE__*/_defineComponent({
  __name: 'UploadTemplate',
  props: {
    id: null,
    name: null,
    modelValue: null,
    accepts: null,
    folder: null,
    multiple: { type: Boolean },
    borderDashed: { type: Boolean },
    inputPlaceholder: null,
    hidePlaceholder: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const { id, name, modelValue, accepts = "*/*", folder = "image", multiple = false, borderDashed = false } = __props as {
    id: string
    name: string
    modelValue: string
    accepts?: string
    folder: string
    multiple?: boolean
    borderDashed?: boolean
    inputPlaceholder?: string
    hidePlaceholder?: boolean
  }

  const files = ref<FileList | []>()
  const filesUploaded: Ref<number> = ref(0)
  const totalFiles: Ref<number> = ref(0)

  const fileLinks: Link[] = []
  // eslint-disable-next-line vue/no-setup-props-destructure
  

  const { value, errorMessage } = useField(name)
  const store = useExternalStore()
  const nbf = jwt.generateNBF()

  const onOpenFile = () => {
    const element = document.getElementById(id)
    if (element) {
      element.click()
    }
  }

  

  const onFileAdd = (event: Event) => {
    files.value = (event.target as HTMLInputElement).files || []
    onUpload()
  }
  const onDragFile = (event: DragEvent) => {
    files.value = event?.dataTransfer?.files || []
    onUpload()
  }

  const beforeUpload = async (file: any) => {
    const type = file.name.split(".").pop() as string
    if (typeof file === "undefined") throw new Error("Please select a file")
    if (accepts === "*/*" || (type?.length && accepts.includes(type))) {
      const totalSize = file?.size ? file?.size / 1000000 : 0
      if (totalSize > 3) throw new Error(`Only accepts max of 3MB size of file`)
      else {
        // upload image
        store.file = file || {}
        store.folder = folder
        const response = await store.uploadFile()
        if (!multiple) {
          value.value = response.link
          emit("update:modelValue", response.link)
        } else {
          filesUploaded.value += 1
          fileLinks.push(response.link)
        }
      }
    } else {
      const toast = await toastController.create({
        message: `Only accepts: ${accepts}`,
        duration: 3000,
        position: "top",
        color: "danger",
      })
      await toast.present()
    }
  }

  const onUpload = async () => {
    try {
      filesUploaded.value = 0
      if (files.value?.length === 1 && !multiple) {
        beforeUpload(first(files.value))
      } else if (multiple) {
        totalFiles.value = files.value?.length || 1
        forEach(files.value, async (value, key) => {
          beforeUpload(value)
        })
      } else throw new Error(files.value?.length ? "You can only add 1 file" : "Please select 1 file")
    } catch (err: any) {
      const toast = await toastController.create({
        message: err || "Something went wrong",
        duration: 3000,
        position: "top",
        color: "danger",
      })
      await toast.present()
    }
  }

  watch(filesUploaded, () => {
    if (filesUploaded.value === totalFiles.value) {
      value.value = fileLinks
      emit("update:modelValue", fileLinks)
      fileLinks.length = 0
    }
  })

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "text-light-gray-200",
    onDragover: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"])),
    onDrop: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
  }, [
    (!__props.modelValue || !__props.modelValue.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["flex flex-col w-full justify-center bg-gray-300 rounded-base h-full cursor-pointer", __props.borderDashed ? 'border-2 border-dashed border-light-gray-200' : '']),
          onClick: onOpenFile,
          onDrop: onDragFile
        }, [
          (!__props.modelValue || !__props.modelValue.length)
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default"),
                (!__props.hidePlaceholder)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.inputPlaceholder || "Upload photo"), 1))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: __props.modelValue,
                  class: "w-full h-full object-cover"
                }, null, 8, _hoisted_4)
              ]))
        ], 34))
      : (__props.modelValue && __props.modelValue.length && __props.folder == 'file')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_unref(XCircleIcon), {
                  class: "absolute w-8 text-error -mt-16 -mr-32 cursor-pointer",
                  onClick: _cache[0] || (_cache[0] = () => emit('update:modelValue', ''))
                }),
                _hoisted_8,
                _createVNode(_unref(DocumentIcon), { class: "w-20 text-white" })
              ]),
              _createElementVNode("span", _hoisted_9, _toDisplayString(__props.modelValue.replace("https://assets.workbean.co/staging/file/", "").replace("https://assets.workbean.co/live/file/", "")), 1)
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "bg-cover bg-no-repeat bg-center h-full w-full rounded-base flex justify-end items-end",
            style: _normalizeStyle({ 'background-image': `url(${__props.modelValue})` })
          }, [
            _createElementVNode("button", {
              class: "bg-white shadow-base rounded-full w-11 h-11 flex items-center justify-center mb-3 mr-3",
              onClick: onOpenFile
            }, [
              _createVNode(_unref(PhotoIcon), { class: "w-8" })
            ])
          ], 4)),
    _createElementVNode("input", {
      id: __props.id,
      name: __props.name,
      type: "file",
      accept: __props.accepts,
      multiple: __props.multiple,
      class: "hidden",
      onInput: onFileAdd
    }, null, 40, _hoisted_10),
    _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(errorMessage)), 1),
    (__props.multiple)
      ? (_openBlock(), _createElementBlock("p", _hoisted_12, "Files uploaded: " + _toDisplayString(filesUploaded.value) + " / " + _toDisplayString(totalFiles.value), 1))
      : _createCommentVNode("", true)
  ], 32))
}
}

})